import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
// import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { UserService } from './user.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

  constructor(private _userService: UserService, private _router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const route = next.routeConfig.path;
    if (!this._userService.isAuthenticated()) {
      // keep the reason in the console: logOut() clears the session, so it can't be read afterwards
      console.warn('[auth-guard] signed out', { route, role: localStorage.getItem('loginAs'), reason: this._userService.getAuthFailure() });
      this._userService?.logOut();
      this._router.navigate(['/login']);
      return false;
    }
    if (this._userService.isAuthorized(route) && this._userService.isPaidUser(route)) {
      return true;
    }
    // Signed in, but this page is not for this role (e.g. a teacher whose browser reopens a
    // remembered /dashboard address). Only school_admin / manager pass isAuthorized() for every
    // page, so every other role used to be signed out here. Send them home and keep the session.
    const home = this._userService.getHomeUrl();
    if (home.split('/')[0] !== route) {
      return this._router.parseUrl(home);
    }
    // their own home page is not allowed either (unknown role or plan): nothing to fall back to
    console.warn('[auth-guard] signed out', { route, role: localStorage.getItem('loginAs'), reason: 'home-not-allowed' });
    this._userService?.logOut();
    this._router.navigate(['/login']);
    return false;
  }
}
